import React from "react";

import DeprecatedButton from "@v1/components/designSystem/button/Button";
import { docs } from "@v2/utils/docs";
import { ArrowUpRight } from "lucide-react";

type SavedStylesEmptyStateProps = {
  title: string;
  showCta?: boolean;
};

const SavedStylesEmptyState: React.FC<SavedStylesEmptyStateProps> = ({
  title,
  showCta = true,
}) => (
  <div className="text-default bg-menu-item-hover flex h-full flex-col items-center justify-center gap-3 rounded-lg p-10 text-center">
    <div className="header-h6">{title}</div>
    <div className="text-muted text-xs">
      Styles allow you to set consistent design styles across colors and text.
    </div>
    {showCta && (
      <DeprecatedButton
        target="_blank"
        variant="tertiary"
        to={docs.savedStyles.main}
        size="sm"
      >
        <div className="flex items-center gap-2 text-xs font-medium">
          Learn More <ArrowUpRight />
        </div>
      </DeprecatedButton>
    )}
  </div>
);

export default SavedStylesEmptyState;
